export default __webpack_public_path__ + "static/media/heineken-back-white.7d8b609b.jpg";